module.exports = __webpack_public_path__ + "static/media/active_directory.22186cee.png";